import { Stack } from '@latitude/layout';
import { Text } from '@latitude/text';
import { cn } from '@latitude/token-utils';
import { Tooltip } from '@latitude/tooltip';
import type { DefaultLabelComponentProps } from 'types';

export const DefaultLabelComponent: React.FC<DefaultLabelComponentProps> = ({
  label,
  labelClassName,
  subtext,
  truncated = false,
}) => {
  // font-size BEFORE leading: twMerge keeps Tailwind's font-size->leading
  // conflict, so a size token clears an EARLIER leading token. Ordering the
  // line-height last keeps both (Anchorage decouples size/line-height).
  const mainTextStyles = cn([
    `font-comp-action-list-medium-font-family`,
    `text-font-comp-action-list-medium-font-size`,
    `font-comp-action-list-medium-font-weight`,
    `leading-font-comp-action-list-medium-line-height`,
    labelClassName,
  ]);

  const subTextStyles = cn([
    `font-comp-action-list-subtext-font-family`,
    `text-font-comp-action-list-subtext-font-size`,
    `font-comp-action-list-subtext-font-weight`,
    `leading-font-comp-action-list-subtext-line-height`,
  ]);

  return truncated ? (
    // we need an overflow tooltip to show the full label, otherwise it will be cut off
    <Tooltip text={<div className="overflow-auto">{label}</div>}>
      <Stack className="[&_div]:overflow-hidden [&_div]:text-ellipsis [&_div]:whitespace-nowrap">
        <Text className={mainTextStyles}>{label}</Text>
        {subtext ? (
          <Text className={subTextStyles} color="muted">
            {subtext}
          </Text>
        ) : (
          <></>
        )}
      </Stack>
    </Tooltip>
  ) : (
    <Stack>
      <Text className={mainTextStyles}>{label}</Text>
      {subtext ? (
        <Text className={subTextStyles} color="muted">
          {subtext}
        </Text>
      ) : (
        <></>
      )}
    </Stack>
  );
};
